import { isString, isFunction, isObjectLike } from 'lodash';

class UtilsService {
    getComponentDisplayName(Component) {
        if (isFunction(Component) || isObjectLike(Component)) {
            return Component.displayName || Component.name || 'Component';
        }
        return '';
    }

    splitName(name) {
        if (!isString(name)) {
            return null;
        }

        let firstname = null;
        let lastname = null;

        if (name.indexOf(' ') === -1) {
            lastname = name;
        } else {
            const splittedName = name.split(' ');
            firstname = splittedName.shift();
            lastname = splittedName.join(' ');
        }

        return { firstname, lastname };
    }

    extractTokenPayload(token) {
        if (
            !isString(token) ||
            token.indexOf('.') === token.lastIndexOf('.') ||
            token.indexOf('.') === -1 ||
            token.lastIndexOf('.') === -1
        ) {
            return null;
        }

        const tokentPayloadStr = token.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
        const tokenPayload = JSON.parse(this.decodeBase64(tokentPayloadStr));

        return tokenPayload;
    }

    /* eslint-disable */
    decodeBase64(s) {
        var e={},i,b=0,c,x,l=0,a,r='',w=String.fromCharCode,L=s.length;
        var A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        for(i=0;i<64;i++){e[A.charAt(i)]=i;}
        for(x=0;x<L;x++){
            c=e[s.charAt(x)];b=(b<<6)+c;l+=6;
            while(l>=8){((a=(b>>>(l-=8))&0xff)||(x<(L-2)))&&(r+=w(a));}
        }
        return r;
    }
    /* eslint-enable */
}

export default new UtilsService();
